import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function login(data) {
  console.log("xxxxrrrtyty")
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}
